import React from 'react';
import cloneDeep from 'lodash/cloneDeep';

const emptyFn = () => {};
const withForm = (WrappedComponent, options) => {
    const validate = options.validate || emptyFn;
    class WithFormComponent extends React.Component {
        constructor(props) {
            super(props);
            this.submit = this.submit.bind(this);
            this.handleTextInputOnChange = this.handleTextInputOnChange.bind(this);
            this.handleListOnChange = this.handleListOnChange.bind(this);
            this.state = {
                canSubmit: false,
                fields: {}
            };
        }

        /**
         * handleListOnChange
         * @param {*} field
         * @param {*} value
         * @param validationContext
         * @param {*} callback
         */
        handleListOnChange = (field, value, validationContext, callback) => {
            const fields = cloneDeep(this.state.fields);
            fields[field] = value;
            this.setState({
                fields
            });
            if (typeof callback === 'function') {
                callback(field, value, fields);
            }
            this.setState({ canSubmit: validate(fields, value, validationContext) });
        }

        /**
         * handleTextInputOnChange
         * @param {*} event
         * @param {*} callback
         * @param {*} rules - refer to utils/invalidCharaters
         */
        handleTextInputOnChange(event, callback, rules) {
            const regexRules = rules || emptyFn;
            const { fields } = this.state;
            const regex = new RegExp(regexRules.call());
            const value = String(event.target.value).trim();
            const field = String(event.target.name);
            if (value !== '' && !regex.test(value)) {
                event.preventDefault();
                return false;
            }
            fields[field] = value;
            this.setState({
                fields
            });
            if (typeof callback === 'function') {
                callback(event, fields);
            }
            this.setState({ canSubmit: validate(fields) });
            return true;
        }

        /**
         * Submit form
         * @param {*} callback
         */
        submit(callback) {
            const { fields } = this.state;
            if (typeof callback === 'function') {
                callback(fields);
            }
        }

        render() {
            const formProps = {
                handleListOnChange: this.handleListOnChange,
                handleTextInputOnChange: this.handleTextInputOnChange,
                submit: this.submit
            };

            return (
                <div className="is-a-form">
                    <WrappedComponent
                        {...this.props}
                        canSubmit={this.state.canSubmit}
                        fields={this.state.fields}
                        form={formProps} />
                </div>
            );
        }
    }

    return WithFormComponent;
};


export default withForm;



// WEBPACK FOOTER //
// ./app/components/with-form.js